import api from "./api";
import { getUser } from "../services/Auth";

export const GetMetricasPedidos = async () => {
  try {
    const user = await getUser();
    const response = await api.get(
      `/pedidos/metricas?estabelecimento=${user.estabelecimento._id}`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const cancelarPedidoApi = async (id_pedido, data) => {
  try {
    const response = await api.put(`/pedidos/${id_pedido}/cancelar`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPedidosByDateRange = async (iniDate, fimDate) => {
  try {
    const user = await getUser();
    let page = 1;
    let pages = 2;
    let pedidos = [];
    while (page < pages) {
      const select =
        "-avaliacao -distancia -itens_trocados -itens_peso_alterado -itens_quantidade_alterada -itens_retirados -itens_adicionados_separacao -opcao_falta_estoque -numeroRepasses";
      const query = `page=${page}&initial_date=${new Date(
        iniDate,
      ).toISOString()}&final_date=${new Date(fimDate).toISOString()}&select=${select}`;
      const { data } = await api.post(
        `/estabelecimentos/${user.estabelecimento._id}/pedidos/status?${query}`,
        {
          status: ["entregue", "entrega_finalizada"],
        },
      );
      page += 1;
      if (data) {
        pages = data.pages;
        pedidos.push(...data.docs);
      }
    }
    return pedidos;
  } catch (error) {
    throw error;
  }
};

export const despacharSeparadorSelecionado = async (id_pedido, id_separador) => {
  try {
    const response = await api.get(
      `/pedidos/${id_pedido}/separador/${id_separador}/despachar`,
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const atualizarStatusPedido = async (id, status) => {
  try {
    const pedido = await api.put(`/pedidos/${id}/status`, { status: status });
    return pedido.data;
  } catch (error) {
    throw error;
  }
};

export const listarPedidos = async (page) => {
  try {
    let usuario = await getUser();
    const pedidos = await api.get(
      `estabelecimentos/${usuario.estabelecimento._id}/pedidos?page=${page}`,
    );
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const listarPedidosPorStatus = async (page, status) => {
  try {
    let usuario = await getUser();
    const pedidos = await api.post(
      `estabelecimentos/${usuario.estabelecimento._id}/pedidos/status?page=${page}`,
      {
        status,
      },
    );
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};

export const AlterarPedido = async (id_pedido, data) => {
  try {
    const pedidos = await api.put(`/pedidos/${id_pedido}`, data);
    return pedidos.data;
  } catch (error) {
    throw error;
  }
};
